<template>
  <div class="list">
    <slot />
  </div>
</template>

<script setup></script>
<style lang="scss" scoped>
.list {
  display: flex;
  flex-direction: row;
  justify-content: center;
  // gap: 40px;
  margin-top: 90px;
  margin-bottom: 220px;
}
@media screen and (max-width: 480px) {
  .list {
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 150px;
  }
}
</style>
